import PropTypes from 'prop-types';
import React from 'react';

class CustomConfigTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
    };
  }

  handleChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  render() {
    const { inputValue } = this.state;

    return (
      <section className="soa-custom-tab">
        <div className="soa-custom-tab-body">
          <label className="soa-custom-tab-label" htmlFor="soa-custom-tab-input">
            Enter value
          </label>
          <input
            className="soa-custom-tab-input"
            id="soa-custom-tab-input"
            placeholder="Type here..."
            type="text"
            value={inputValue}
            onChange={this.handleChange}
          />
        </div>
      </section>
    );
  }
}

CustomConfigTab.defaultProps = {
  selectedCountry: null,
};

CustomConfigTab.propTypes = {
  selectedCountry: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default CustomConfigTab;
